import './style.scss';

import { Layout } from 'antd';
import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useLocation } from 'react-router-dom';

import { ENABLE_LANDING_PAGE } from '../../constants';
import Header from '../common/header';
import FooterApp from '../footer-app';
import HeaderApp from '../header-app';
import ToastNoti from '../Noti';
import SideBar from '../sidebar';

const { Content } = Layout;

const MainContent = ({ children }: any) => {
  const [dataFromSidebar, setDataFromSidebar] = useState();

  const callbackFunction = (childData: any) => {
    setDataFromSidebar(childData);
  };

  return isMobile ? (
    <>
      <div className="row-layout mobile-layout">
        <div
          className={
            dataFromSidebar ? 'flex-layout flex-layout-collapse' : 'flex-layout'
          }
        >
          <div className="left flew-mobile-responsive">
            <SideBar callbackFunction={callbackFunction} />
          </div>
          <div className="right">
            <HeaderApp />
            <Content>{children}</Content>
            <FooterApp />
          </div>
        </div>
        <ToastNoti />
      </div>
    </>
  ) : (
    <>
      <div className="row-layout">
        <div
          className={
            dataFromSidebar ? 'flex-layout flex-layout-collapse' : 'flex-layout'
          }
        >
          <div className="left">
            <SideBar callbackFunction={callbackFunction} />
          </div>
          <div className="right">
            <HeaderApp />
            <Content>{children}</Content>
            <FooterApp />
          </div>
        </div>
        <ToastNoti />
      </div>
    </>
  );
};

function Main({ children }: any) {
  const location = useLocation();
  let pathUrl = location?.pathname.split('/');

  return (
    <Layout>
      {ENABLE_LANDING_PAGE ? (
        <>
          {pathUrl[1] === 'apps' ? (
            <MainContent>{children}</MainContent>
          ) : (
            <>
              <Header />
              <Content>{children}</Content>
              <div className="container">
                <FooterApp />
              </div>
            </>
          )}
        </>
      ) : (
        <MainContent>{children}</MainContent>
      )}
    </Layout>
  );
}

export default Main;
